import { ApiClientService } from '../../services/generated/index';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormService } from '../../services/form.service';
import { environment } from '../../environments/environment';
import { FileSelectDirective, FileUploader, FileItem } from 'ng2-file-upload/ng2-file-upload';
import { minmaxValidator } from '../Validators/minmaxvalidator.directive';

import {
  Form,
  Step,
  Question,
  Section,
  DecisionServiceVersion,
  Decision,
  ApiExecutionRequest,
  ExecutionRequestData,
  ExecutionResult,
  HitConclusion,
  Respond,
  RespondAnswer,
  PublishedForm,
  Respondent
} from '../../services/generated/models';
import { forEach } from '@angular/router/src/utils/collection';

declare var $: any;

@Component({
  selector: 'app-publicform',
  templateUrl: './publicform.component.html',
  styleUrls: ['./publicform.component.css'],
})
export class PublicformComponent implements OnInit {
  isPreview = false;
  isRespond = false;
  guid: string;
  template: number;
  frame: number;
  showAllSteps: number;
  extraCss: string;
  password = '';
  currentStep = 0;
  askPassword = false;
  passwordEnteredWrong = false;
  collapsed: { [id: number]: boolean };
  executing = false;
  executed = false;
  currentResponse: Respond;
  version: number;
  mailSent = false;
  email = '';

  // upload file;
  uploadFileURL = '';
  public uploader: FileUploader;

  thresholdConfigs: { [questionid: number]: any; } = {};

  tc = {
    '0': { color: '#0c5460' },
    '40': { color: '#0c5460' },
    '75.5': { color: '#0c5460' }
  };


  executeStep: () => void;

  constructor(
    private serviceClient: ApiClientService,
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService) {
    this.uploadFileURL = environment.formsapi.url + '/question/file/upload';
    this.uploader = new FileUploader({ url: this.uploadFileURL, queueLimit: 1 });
  }

  ngOnInit() {
    const that = this;
    that.isPreview = (that.route.snapshot.url[0].path === 'preview');
    that.isRespond = (that.route.snapshot.url[0].path === 'respond');
    that.guid = that.route.snapshot.paramMap.get('guid');
    that.version = +that.route.snapshot.paramMap.get('version');
    that.template = +that.route.snapshot.paramMap.get('template');
    that.frame = +that.route.snapshot.paramMap.get('frame');
    that.showAllSteps = +that.route.snapshot.paramMap.get('allsteps');

    // Get the form's data
    if (!that.isRespond) {
      if (that.version > 0) {
        that.serviceClient.FormApi_GetByGuidAndVersion(that.guid, that.version).subscribe(response => {
          that.formService.currentForm = response;
          that.setupForm();
        });
      } else {
        that.serviceClient.FormApi_GetByGuid(that.guid).subscribe(response => {
          that.formService.currentForm = response;
          that.setupForm();
        });
      }
    } else {
      // also get the respond
      that.serviceClient.FormApi_GetByRespondGuid(that.guid).subscribe(response => {
        that.formService.currentForm = response;
        console.log(that.formService.currentForm);
        that.setupForm();
      });
      that.serviceClient.RespondApi_GetByGuid(that.guid)
        .subscribe(response => {
          that.currentResponse = response;
          console.log('resp', that.currentResponse);
        });
    }

    // Get the theme data (if necessary)
    if (that.template !== 0) {
      that.serviceClient.TemplateApi_Get(that.template).subscribe(response => {
        that.formService.currentTheme = response;
        that.formService.currentThemeLoaded = true;
        that.injectExtraCss();
      });
    }
  }

  public ExecuteStep(): void {
    const that = this;
    // If there are decisions to execute ...
    if (that.formService.currentForm.Steps[that.currentStep].Decisions.length > 0) {
      that.formService.currentForm.Steps[that.currentStep].ExecutionResults = [];
      let executionCounter = 0;
      // Execute each decision
      that.executing = true;
      that.formService.currentForm.Steps[that.currentStep].Decisions.forEach(decision => {
        const execrequest = new ApiExecutionRequest();
        execrequest.DecisionServiceId = decision.DecisionServiceId;
        execrequest.VersionNumber = decision.VersionNumber;
        execrequest.ExecutionRequestData = that.getFilledInRequestData(decision);
        execrequest.ExecutionRequestMetaData = that.getFilledInRequestMetaData(decision);
        if (that.isPreview) {
          execrequest.Reference = 'preview#' + that.formService.currentForm.Guid + '#';
        } else {
          execrequest.Reference = 'form#' + that.formService.currentForm.Guid + '#' + that.currentResponse.Id + '#' + decision.DecisionServiceId;
        }
        console.log('request', execrequest);
        that.serviceClient.RespondApi_Execute(execrequest, that.formService.currentForm.Guid)
          .subscribe(response => {
            response.DecisionId = decision.Id;
            console.log('execresp', response);
            that.formService.currentForm.Steps[that.currentStep].ExecutionResults.push(response);
            executionCounter++;
            // men mag alleen naar de volgende stap gaan als alle decisions uitgevoerd zijn (kan misschien mislopen)
            if (+executionCounter === +that.formService.currentForm.Steps[that.currentStep].Decisions.length) {
              that.executing = false;
              that.executed = true;
              that.goToNextStep();
            }
          });
      });
    } else {
      that.goToNextStep();
    }
  };

  private goToNextStep(): void {
    const that = this;
    that.executed = false;
    if (that.currentStep <= that.formService.currentForm.Steps.length - 1) {
      that.collapsed[that.formService.currentForm.Steps[that.currentStep].Id] = true;
      that.currentStep++;

      if (that.formService.currentForm.Steps[that.currentStep] != null) {
        while (that.currentStep < that.formService.currentForm.Steps.length && that.formService.showStep(that.formService.currentForm.Steps[that.currentStep], false) === false) {
          that.collapsed[that.formService.currentForm.Steps[that.currentStep].Id] = false;
          that.currentStep++;
        }
      }

      if (!that.formService.currentForm.ShowSummary && that.currentStep === that.formService.currentForm.Steps.length - 1) {
        that.updateResponse();
      }
    }

    if (that.currentStep >= that.formService.currentForm.Steps.length) {
      that.updateResponse();
      that.currentStep++;
      if (that.formService.currentForm.ShowSummary) {
        if (this.isRespond) {
          that.router.navigate([`/summary/${this.formService.currentForm.Guid}/${this.template}/${this.frame}`]);
        } else {
          that.router.navigate([`/summary/${this.guid}/${this.template}/${this.frame}`]);
        }
      }
    }
  }

  private injectExtraCss(): void {
    const that = this;
    if (this.formService.currentThemeLoaded && this.formService.currentTheme.ExtraCss !== '') {

      this.extraCss = '<style>' + this.formService.currentTheme.ExtraCss + '</style>';

      // Use jquery to inject the extra css
      const $head = $('head');
      const $headlinklast = $head.find('link[rel=\'stylesheet\']:last');
      if ($headlinklast.length) {
        $headlinklast.after(this.extraCss);
      } else {
        $head.append(this.extraCss);
      }
    }
  }

  private getFilledInRequestData(decision: Decision): ExecutionRequestData[] {
    const that = this;
    let stepCounter = 0;
    const execRequestData: ExecutionRequestData[] = [];
    const busdataIds = decision.BusinessDataIds ? decision.BusinessDataIds.split(';') : null;
    if (busdataIds == null) { return execRequestData };
    while (stepCounter <= that.currentStep) {
      const step = that.formService.currentForm.Steps[stepCounter];
      step.Questions.forEach(question => {
        if (!question.IsMetaData && busdataIds.indexOf(question.BusinessDataId.toString()) > -1) {
          const reqData = new ExecutionRequestData;
          reqData.Key = question.BusinessDataId;
          reqData.Value = question.Answer != null ? question.Answer : '';
          execRequestData.push(reqData);
        }
      });
      step.Sections.forEach(section => {
        section.Questions.forEach(question => {
          if (!question.IsMetaData && busdataIds.indexOf(question.BusinessDataId.toString()) > -1) {
            const reqData = new ExecutionRequestData;
            reqData.Key = question.BusinessDataId;
            reqData.Value = question.Answer != null ? question.Answer : '';
            execRequestData.push(reqData);
          }
        });
      });
      stepCounter++;
    }
    return execRequestData;
  }

  private getFilledInRequestMetaData(decision: Decision): ExecutionRequestData[] {
    const that = this;
    let stepCounter = 0;
    const execRequestData: ExecutionRequestData[] = [];
    const busdataIds = decision.BusinessMetaDataIds ? decision.BusinessMetaDataIds.split(';') : null;
    if (busdataIds == null) { return execRequestData };
    while (stepCounter <= that.currentStep) {
      const step = that.formService.currentForm.Steps[stepCounter];
      step.Questions.forEach(question => {
        if (question.IsMetaData && busdataIds.indexOf(question.BusinessDataId.toString()) > -1) {
          const reqData = new ExecutionRequestData;
          reqData.Key = question.BusinessDataId;
          reqData.Value = question.Answer != null ? question.Answer : '';
          execRequestData.push(reqData);
        }
      });
      step.Sections.forEach(section => {
        section.Questions.forEach(question => {
          if (question.IsMetaData && busdataIds.indexOf(question.BusinessDataId.toString()) > -1) {
            const reqData = new ExecutionRequestData;
            reqData.Key = question.BusinessDataId;
            reqData.Value = question.Answer != null ? question.Answer : '';
            execRequestData.push(reqData);
          }
        });
      });
      stepCounter++;
    }
    return execRequestData;
  }

  public onSubmit(): void {
    const that = this;
    let value = that.password;
    if (that.password === '') {
      value = '{EMPTYYO}';
    }

    that.serviceClient.FormApi_ConfirmPassword(value, that.formService.currentForm.Guid)
      .subscribe(response => {
        that.passwordEnteredWrong = !response;
        if (!that.passwordEnteredWrong) {
          that.askPassword = false;
        }
        that.password = '';
      });
  }

  public constructPattern(decimalPlaces: number): string {
    const that = this;
    let result = '^(-?\\d*';
    if (decimalPlaces > 0) {
      result += '(\\.\\d{1,' + decimalPlaces + '})?';
    }
    result += ')$';
    return result;
  }

  public updateResponse(): void {
    const that = this;
    if (!that.isPreview) {
      that.currentResponse.RespondAnswers = [];
      that.currentResponse.CompletionDate = new Date();
      that.formService.currentForm.Steps.forEach(step => {
        step.Sections.forEach(section => {
          section.Questions.forEach(question => {
            const newRespondAnswer = new RespondAnswer();
            newRespondAnswer.Answer = question.Answer;
            newRespondAnswer.QuestionId = question.Id;
            newRespondAnswer.RespondId = that.currentResponse.Id;
            that.currentResponse.RespondAnswers.push(newRespondAnswer);
          });
        });
        step.Questions.forEach(question => {
          const newRespondAnswer = new RespondAnswer();
          newRespondAnswer.Answer = question.Answer;
          newRespondAnswer.QuestionId = question.Id;
          newRespondAnswer.RespondId = that.currentResponse.Id;
          that.currentResponse.RespondAnswers.push(newRespondAnswer);
        });
      });
      that.serviceClient.RespondApi_Put(that.currentResponse)
        .subscribe(response => {
          // No response
        });
    }
  }

  public getDecisionName(execResult: ExecutionResult): string {
    const that = this;
    let result = '';

    that.formService.currentForm.Steps[that.currentStep].Decisions.forEach(decision => {
      if (decision.Id === execResult.DecisionId) {
        result = decision.Name;
      }
    });

    return result;
  }

  public getDecisionResult(execResult: ExecutionResult): string {
    const that = this;
    let result = '';

    execResult.HitConclusions.forEach(hc => {
      if (hc.BusinessDataId === +execResult.ViewModelFinalConclusionBusinessDataIds) {
        result = hc.Value;
      }
    });

    return result;
  }

  private createResponse() {
    const that = this;
    that.currentResponse = new Respond();
    that.currentResponse.CreateDate = new Date();
    that.currentResponse.FormId = that.formService.currentForm.Id;
    that.currentResponse.RespondAnswers = [];
    that.serviceClient.RespondApi_Post(that.currentResponse)
      .subscribe(respondresponde => {
        that.currentResponse = respondresponde;
      });
  }

  public getPercentage(question: Question): number {
    const that = this;
    let result = 0;
    let busdataId = 0;
    let executionValue = '';
    const allExecutionResults = that.formService.getAllExecutionResults();

    const r = allExecutionResults.find(x => x.DecisionId === question.PercentageResultDecisionId);
    if (r && !(+r.ConclusionValueType === 0 && question.PercentageResultBusinessDataId === 0)) {
      busdataId = (question.PercentageResultBusinessDataId > 0) ? question.PercentageResultBusinessDataId : +r.ViewModelFinalConclusionBusinessDataIds;
      r.HitConclusions.forEach(hc => {
        if (hc.BusinessDataId === busdataId) {
          executionValue = hc.Value;
        }
      });
      if (executionValue !== '') {
        result = +executionValue * 100;
      };
      return result;
    }
  }

  public getThreshold(question: Question): any {
    const that = this;
    if (question != null && !question.PercentageResultUseThreshold) {
      return that.tc;
    } else {
      if (that.thresholdConfigs != null && that.thresholdConfigs[question.Id] != null) {
        return that.thresholdConfigs[question.Id];
      } else {
        return that.tc;
      }
    }
  }

  public sendRespond(): void {
    const that = this;
    const respondForm = that.formService.getRespond();

    const respondent = new Respondent();
    respondent.Form = respondForm;
    respondent.Email = that.email;
    that.serviceClient.FormApi_SendRespond(respondent)
      .subscribe(response => {
      });

    that.mailSent = true;
  }

  public constructInstructionalTextData(question: Question): string {
    const that = this;
    let result = question.Name;
    let executionValue = '';
    let busdataId = 0;
    const allQuestions = that.formService.getAllQuestions();
    const allExecutionResults = that.formService.getAllExecutionResults();
    const allOutputData = that.formService.getAllOutputData();

    if (question.Variables == null) {
      return result;
    }
    question.Variables.forEach(v => {
      if (v.ValueQuestionId > 0) {
        const q = allQuestions.find(x => x.Id === v.ValueQuestionId);
        if (q) {
          if (q.ValueListId > 0) {
            const t = that.formService.currentForm.Texts.find(x => x.ValueListId === q.ValueListId && x.DefaultValue === q.Answer);
            if (t) {
              result = result.replace(new RegExp('#' + v.Key, 'g'), t.CustomValue);
            } else {
              result = result.replace(new RegExp('#' + v.Key, 'g'), q.Answer);
            }
          } else if (q.PairId > 0) {
            const t = that.formService.currentForm.Texts.find(x => x.PairId === q.PairId);
            if (t) {
              if (q.Answer === q.Pair.ValueForFalse) {
                result = result.replace(new RegExp('#' + v.Key, 'g'), t.ValueForFalse);
              } else {
                result = result.replace(new RegExp('#' + v.Key, 'g'), t.ValueForTrue);
              }
            } else {
              result = result.replace(new RegExp('#' + v.Key, 'g'), q.Answer);
            }
          } else {
            if (q.Type === 'DateTimeData') {
              result = result.replace(new RegExp('#' + v.Key, 'g'), that.formService.convertDateTime(q));
            } else {
              if (q.Type === 'PercentageData') {
                result = result.replace(new RegExp('#' + v.Key, 'g'), that.formService.convertPercentage(q));
              } else {
                result = result.replace(new RegExp('#' + v.Key, 'g'), q.Answer);
              }
            }
          }
        }
      } else {
        if (allExecutionResults == null) {
          result = result.replace(new RegExp('#' + v.Key, 'g'), 'Sorry, no result');
        } else {
          const r = allExecutionResults.find(x => x.DecisionId === v.ValueDecisionId);
          if (r && !(+r.ConclusionValueType === 0 && v.ValueIntermediateBusinessDataId === 0)) {
            busdataId = (v.ValueIntermediateBusinessDataId > 0) ? v.ValueIntermediateBusinessDataId : +r.ViewModelFinalConclusionBusinessDataIds;
            r.HitConclusions.forEach(hc => {
              if (hc.BusinessDataId === busdataId) {
                executionValue = hc.Value;
                const outputdata = allOutputData.find(data => data.BusinessDataId === hc.BusinessDataId);
                if (outputdata != null) {
                  if (outputdata.Unit === '%') {
                    executionValue = '' + (+executionValue * 100);
                  }
                  if (outputdata.Unit === '€') {
                    executionValue = outputdata.Unit + ' ' + executionValue;
                  } else {
                    executionValue += ' ' + outputdata.Unit
                  }
                }
              }
            });
            if (executionValue === '') {
              result = 'Sorry, no result';
            } else {
              result = result.replace(new RegExp('#' + v.Key, 'g'), executionValue);
            }
          } else {
            result = 'Sorry, no result';
          }
        }
      }
    });
    return result;
  }

  setupForm() {
    const that = this;
    // Thresholds
    const allQuestions = that.formService.getAllQuestions();
    allQuestions.forEach(q => {
      if (q.PercentageResultUseThreshold) {
        const v1 = q.PercentageResultThresholdValue1.toString();
        const v2 = q.PercentageResultThresholdValue2.toString();
        const t = {
          '0': { color: q.PercentageResultThresholdColor1 },
          [v1]: { color: q.PercentageResultThresholdColor2 },
          [v2]: { color: q.PercentageResultThresholdColor3 }
        };
        that.thresholdConfigs[q.Id] = t;
      }
    });


    if (!that.isPreview) {
      const publishedForm = (that.formService.currentForm as PublishedForm);
      // if the form is not in the active state yet or is null, redirect to 404 page
      const activatedState = 1;
      if (publishedForm == null || +publishedForm.FormState !== activatedState) {
        that.router.navigate(['404']);
      }

      // check the dates
      const today = new Date();
      const from = new Date(publishedForm.FromDate);
      from.setHours(0, 0, 0);
      const to = new Date(publishedForm.ToDate);
      to.setHours(0, 0, 0);

      if (!(today >= from && today <= to)) {
        that.router.navigate(['404']);
      } else {
        if (!that.isRespond) {
          that.createResponse();
        }
      }
    }

    that.collapsed = {};
    let stepcollapse = false;
    that.formService.currentForm.Steps.forEach(step => {
      that.collapsed[step.Id] = stepcollapse;
      stepcollapse = true;
    });

    // ask password if necessary
    if (that.formService.currentForm.DataType === 'PublishedForm') {
      if ((that.formService.currentForm as PublishedForm).Password === 'true') {
        that.askPassword = true;
      }
    }
    that.formService.currentFormLoaded = true;
  }

  onPercentModelChange(ev, question: Question) {
    const that = this;
    if (ev != null) {
      question.Answer = (+ev / 100) + '';
    }
  }

  onDateTimeModelChange(ev, question: Question) {
    const that = this;
    if (ev != null) {
      const index = ev.indexOf('T');
      question.Answer = ev.substr(0, index) + ' ' + ev.substr(index + 1);
    }
  }

  onDateTimeBlur(question: Question) {
    const c = (question.Answer.match(new RegExp(':', 'g')) || []).length;
    if (c === 1) {
      question.Answer = question.Answer + ':00';
    }
  }

  getQuestionAnswer(question: Question) {
    return question.Answer == null || question.Answer === '' ? question.MinimumValue : question.Answer;
  }

  sliderOnFinish(ev, question: Question) {
    question.Answer = ev.from;
  }

  sliderOnStart(ev, question: Question) {
    if (question.Answer == null || question.Answer === '') {
      question.Answer = ev.min;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/publicform/publicform.component.ts